import React from "react";
import { useParams, Link } from "react-router-dom";
import "../CSS/BlogDetails.css";

// Import your assets
import blog1 from "../Assets/blog1.png";
import blog2 from "../Assets/blog2.png";
import blog3 from "../Assets/blog3.png";

export default function BlogDetails() {
  const { slug } = useParams();

  const blogData = [
    {
      slug: "documents-required-for-apostille-india",
      title: "Documents Required for Apostille in India",
      image: blog3,
      date: "07-04-2026",
      readTime: "5 min read",
      author: "Adv. Neeraj Pandey",
      content: [
        {
          type: "paragraph",
          text: "Apostille is a crucial process for document legalization when you plan to use your documents internationally. Whether you are going abroad for higher education, employment, or business purposes, understanding the documents required for apostille in India is essential for a smooth process."
        },
        {
          type: "heading",
          text: "What is Apostille?"
        },
        {
          type: "paragraph",
          text: "Apostille is a certificate issued by the Ministry of External Affairs (MEA), Government of India, that authenticates the origin of a public document. It is required for countries that are members of the Hague Apostille Convention of 1961."
        },
        {
          type: "heading",
          text: "Personal Documents Required for Apostille"
        },
        {
          type: "subheading",
          text: "1. Birth Certificate Apostille"
        },
        {
          type: "paragraph",
          text: "Birth certificate apostille is required for immigration, family visa, residency permits, and marriage registration abroad. The original birth certificate issued by the municipal corporation or registrar of births is accepted for apostille."
        },
        {
          type: "subheading",
          text: "2. Marriage Certificate Apostille"
        },
        {
          type: "paragraph",
          text: "Marriage certificate apostille is essential for spouse visa applications, family reunification, and name change after marriage. The marriage certificate must be issued by the registrar of marriages or religious authority."
        },
        {
          type: "subheading",
          text: "3. Police Clearance Certificate (PCC) Apostille"
        },
        {
          type: "paragraph",
          text: "Police Clearance Certificate is required for work visas, residency permits, and immigration to many countries. PCC is issued by the Regional Passport Office or local police station after verification of your criminal record."
        },
        {
          type: "subheading",
          text: "4. Affidavit Apostille"
        },
        {
          type: "paragraph",
          text: "Affidavits are legal documents used for various purposes including name change, address proof, and relationship verification. The affidavit must be notarized before proceeding for apostille."
        },
        {
          type: "heading",
          text: "Educational Documents Required for Apostille"
        },
        {
          type: "subheading",
          text: "1. Degree Certificate Apostille"
        },
        {
          type: "paragraph",
          text: "Degree certificates from UGC recognized universities can be apostilled. This includes Bachelor's degrees, Master's degrees, and Doctoral degrees. The degree certificate must be original and issued by the university."
        },
        {
          type: "subheading",
          text: "2. Diploma Certificate Apostille"
        },
        {
          type: "paragraph",
          text: "Diploma certificates from recognized institutions, including polytechnic diplomas, are eligible for apostille. The diploma should be issued by a government-approved educational body."
        },
        {
          type: "subheading",
          text: "3. Transcripts and Mark Sheets Apostille"
        },
        {
          type: "paragraph",
          text: "Academic transcripts and mark sheets are often required alongside degree certificates for university admissions abroad. These documents provide detailed information about your academic performance."
        },
        {
          type: "subheading",
          text: "4. HSC/SSLC Certificate Apostille"
        },
        {
          type: "paragraph",
          text: "Higher Secondary Certificate (HSC) and Secondary School Leaving Certificate (SSLC) are required for undergraduate admissions and some visa categories. These certificates are issued by state education boards or CBSE."
        },
        {
          type: "heading",
          text: "Commercial Documents Required for Apostille"
        },
        {
          type: "subheading",
          text: "1. Certificate of Incorporation"
        },
        {
          type: "paragraph",
          text: "Companies expanding internationally need apostille on their Certificate of Incorporation. This document proves the legal existence of your company in India."
        },
        {
          type: "subheading",
          text: "2. Memorandum of Association (MOA) & Articles of Association (AOA)"
        },
        {
          type: "paragraph",
          text: "MOA and AOA are fundamental documents for any company. They define the company's objectives and internal regulations. These documents require apostille for international business transactions."
        },
        {
          type: "subheading",
          text: "3. Power of Attorney (POA) Apostille"
        },
        {
          type: "paragraph",
          text: "Power of Attorney is a legal document authorizing someone to act on your behalf. POA apostille is required for property transactions, business deals, and legal proceedings abroad."
        },
        {
          type: "subheading",
          text: "4. Export Documents Apostille"
        },
        {
          type: "paragraph",
          text: "Export documents such as invoices, bills of lading, and certificates of origin need apostille for international trade. These documents facilitate customs clearance and prove the origin of goods."
        },
        {
          type: "heading",
          text: "Additional Documents Required for Apostille"
        },
        {
          type: "subheading",
          text: "Passport Copy"
        },
        {
          type: "paragraph",
          text: "A clear copy of your passport (first and last page) is required for all apostille applications. The passport copy serves as proof of identity and must be valid."
        },
        {
          type: "subheading",
          text: "Authorization Letter"
        },
        {
          type: "paragraph",
          text: "If you are using a service provider for apostille, you need to provide an authorization letter authorizing them to process your documents on your behalf."
        },
        {
          type: "heading",
          text: "Documents That Cannot Be Apostilled"
        },
        {
          type: "paragraph",
          text: "The following documents cannot be apostilled:"
        },
        {
          type: "list",
          items: [
            "Laminated documents (the apostille stamp cannot be placed on laminated paper)",
            "Photocopies (only original documents are accepted)",
            "Documents with alterations or corrections without proper authentication",
            "Expired documents",
            "Documents issued in a foreign language without certified translation"
          ]
        },
        {
          type: "heading",
          text: "The Apostille Process in India"
        },
        {
          type: "paragraph",
          text: "The apostille process in India follows these steps:"
        },
        {
          type: "numbered-list",
          items: [
            "Notary Attestation (for personal and commercial documents)",
            "State/Home Department Attestation (for educational documents)",
            "HRD Attestation (for educational documents from certain states)",
            "SDM Attestation (alternative to state attestation)",
            "MEA Apostille (final apostille stamp from Ministry of External Affairs)"
          ]
        },
        {
          type: "heading",
          text: "Processing Time for Apostille"
        },
        {
          type: "paragraph",
          text: "The processing time for apostille in India typically ranges from 2 to 7 working days, depending on the document type and state of origin. Educational documents may take longer due to HRD verification, which can take 10-15 working days. Commercial documents are usually processed faster, within 2-3 working days."
        },
        {
          type: "heading",
          text: "Why Choose Professional Apostille Services?"
        },
        {
          type: "paragraph",
          text: "Professional apostille service providers like Advocate Pandey & Associates offer several advantages:"
        },
        {
          type: "list",
          items: [
            "Expert knowledge of document requirements",
            "Doorstep document pickup and delivery",
            "Faster processing through established relationships with authorities",
            "Real-time tracking of your documents",
            "Assistance with incomplete or problematic documents",
            "Competitive pricing with no hidden charges"
          ]
        },
        {
          type: "heading",
          text: "Countries That Accept Apostille"
        },
        {
          type: "paragraph",
          text: "The Hague Apostille Convention has 120+ member countries including the United States, United Kingdom, Australia, Canada, France, Germany, Italy, Spain, Japan, South Korea, United Arab Emirates, and many more. For non-member countries, embassy attestation is required instead of apostille."
        },
        {
          type: "heading",
          text: "Frequently Asked Questions"
        },
        {
          type: "subheading",
          text: "Q: Can I apostille documents myself?"
        },
        {
          type: "paragraph",
          text: "Yes, you can personally visit the MEA office in Delhi, Mumbai, Chennai, Kolkata, or Hyderabad. However, using a professional service saves time and effort."
        },
        {
          type: "subheading",
          text: "Q: How long is an apostille valid?"
        },
        {
          type: "paragraph",
          text: "An apostille does not have an expiry date. However, some countries may require documents issued within 6 months to 1 year for certain purposes like marriage or immigration."
        },
        {
          type: "subheading",
          text: "Q: What if my university is not on the MEA approved list?"
        },
        {
          type: "paragraph",
          text: "If your university is not on the MEA approved list, you cannot get apostille. You will need to check with your university about their recognition status or consider alternative attestation options."
        },
        {
          type: "heading",
          text: "Conclusion"
        },
        {
          type: "paragraph",
          text: "Understanding the documents required for apostille in India is the first step towards successful document legalization. Whether you need personal, educational, or commercial documents apostilled, having the correct documentation in order will ensure a smooth and timely process. Contact Advocate Pandey & Associates for expert assistance with all your apostille needs."
        }
      ]
    },
    {
      slug: "apostille-vs-attestation-difference",
      title: "Apostille vs Attestation: Key Differences Explained",
      image: blog2,
      date: "05-04-2026",
      readTime: "7 min read",
      author: "Adv. Neeraj Pandey",
      content: [
        {
          type: "paragraph",
          text: "When planning to use Indian documents abroad, you will encounter two terms: Apostille and Attestation. While both are methods of document legalization, they differ significantly in process, purpose, and applicable countries. Understanding these differences is crucial for choosing the right service for your needs."
        },
        {
          type: "heading",
          text: "What is Apostille?"
        },
        {
          type: "paragraph",
          text: "Apostille is a simplified document legalization process introduced by the Hague Convention of 1961. It is a single certificate issued by the Ministry of External Affairs (MEA) that authenticates the origin of a public document. The apostille certificate is attached to your original document and is recognized by all member countries of the Hague Convention."
        },
        {
          type: "heading",
          text: "What is Attestation?"
        },
        {
          type: "paragraph",
          text: "Attestation is a multi-step document verification process required for countries that are NOT members of the Hague Convention. It involves verification from multiple authorities including state government, MEA, and finally the embassy of the destination country. Attestation is more time-consuming and complex than apostille."
        },
        {
          type: "heading",
          text: "Key Differences Between Apostille and Attestation"
        },
        {
          type: "subheading",
          text: "1. Applicable Countries"
        },
        {
          type: "paragraph",
          text: "Apostille is applicable only for Hague Convention member countries (120+ countries including USA, UK, Australia, France, Germany, Spain, Japan). Attestation is required for non-Hague Convention countries (including UAE, Saudi Arabia, Qatar, Kuwait, Oman, Bahrain, Egypt, China)."
        },
        {
          type: "subheading",
          text: "2. Number of Steps"
        },
        {
          type: "paragraph",
          text: "Apostille requires fewer steps: Notary → State/HRD/SDM → MEA Apostille (3-4 steps). Attestation requires more steps: Notary → State → MEA → Embassy Attestation (4-5 steps, sometimes more for certain countries)."
        },
        {
          type: "subheading",
          text: "3. Processing Time"
        },
        {
          type: "paragraph",
          text: "Apostille typically takes 2-7 working days. Attestation takes longer, usually 10-20 working days, depending on the embassy's processing time."
        },
        {
          type: "subheading",
          text: "4. Cost"
        },
        {
          type: "paragraph",
          text: "Apostille is generally more affordable as it involves fewer authorities. Attestation is more expensive due to embassy fees and additional verification steps."
        },
        {
          type: "subheading",
          text: "5. Final Authority"
        },
        {
          type: "paragraph",
          text: "For apostille, the final authority is the Ministry of External Affairs (MEA), India. For attestation, the final authority is the embassy of the destination country located in India."
        },
        {
          type: "heading",
          text: "When Do You Need Apostille?"
        },
        {
          type: "paragraph",
          text: "You need apostille when:"
        },
        {
          type: "list",
          items: [
            "You are traveling to a Hague Convention country",
            "Applying for a student visa to countries like USA, UK, Australia, Canada",
            "Seeking employment in European countries",
            "Immigrating to countries like New Zealand or Japan",
            "Getting married in a Hague member country"
          ]
        },
        {
          type: "heading",
          text: "When Do You Need Attestation?"
        },
        {
          type: "paragraph",
          text: "You need attestation when:"
        },
        {
          type: "list",
          items: [
            "You are traveling to a non-Hague Convention country like UAE, Saudi Arabia, Qatar",
            "Applying for a work visa to Gulf countries",
            "Seeking employment in China or Egypt",
            "Business expansion in Middle Eastern countries",
            "Higher education in non-member countries"
          ]
        },
        {
          type: "heading",
          text: "Document-Specific Differences"
        },
        {
          type: "subheading",
          text: "Educational Documents"
        },
        {
          type: "paragraph",
          text: "For apostille: Educational documents require HRD attestation (for some states) followed by MEA apostille. For attestation: Educational documents need HRD attestation + MEA attestation + Embassy attestation."
        },
        {
          type: "subheading",
          text: "Personal Documents"
        },
        {
          type: "paragraph",
          text: "For apostille: Personal documents need notary + SDM/State + MEA apostille. For attestation: Personal documents need notary + State/Home Department + MEA + Embassy attestation."
        },
        {
          type: "subheading",
          text: "Commercial Documents"
        },
        {
          type: "paragraph",
          text: "For apostille: Commercial documents need notary + Chamber of Commerce + MEA apostille. For attestation: Commercial documents need notary + Chamber of Commerce + MEA + Embassy attestation."
        },
        {
          type: "heading",
          text: "Which Countries Require Apostille?"
        },
        {
          type: "paragraph",
          text: "Major countries requiring apostille include:"
        },
        {
          type: "list",
          items: [
            "United States of America (USA)",
            "United Kingdom (UK)",
            "Australia",
            "Canada",
            "France",
            "Germany",
            "Italy",
            "Spain",
            "Netherlands",
            "Switzerland",
            "Japan",
            "South Korea",
            "New Zealand",
            "Singapore",
            "Greece",
            "Portugal",
            "Sweden",
            "Norway",
            "Denmark",
            "Finland"
          ]
        },
        {
          type: "heading",
          text: "Which Countries Require Attestation?"
        },
        {
          type: "paragraph",
          text: "Major countries requiring attestation include:"
        },
        {
          type: "list",
          items: [
            "United Arab Emirates (UAE)",
            "Saudi Arabia",
            "Qatar",
            "Kuwait",
            "Oman",
            "Bahrain",
            "China",
            "Egypt",
            "Lebanon",
            "Jordan",
            "Libya",
            "Sudan",
            "Iraq",
            "Iran"
          ]
        },
        {
          type: "heading",
          text: "How to Choose the Right Service?"
        },
        {
          type: "paragraph",
          text: "To determine whether you need apostille or attestation:"
        },
        {
          type: "numbered-list",
          items: [
            "Check the destination country's membership in the Hague Convention",
            "Confirm with your employer, university, or immigration officer",
            "Consult with a professional attestation service provider",
            "Check the specific requirements for your document type"
          ]
        },
        {
          type: "heading",
          text: "Can You Convert Attestation to Apostille?"
        },
        {
          type: "paragraph",
          text: "No, you cannot convert attestation to apostille. If your document has already been attested for a non-Hague country, you cannot use the same document for a Hague country. You will need to get a fresh apostille on the document."
        },
        {
          type: "heading",
          text: "Why Choose Professional Services?"
        },
        {
          type: "paragraph",
          text: "Professional attestation and apostille services offer:"
        },
        {
          type: "list",
          items: [
            "Correct guidance on whether you need apostille or attestation",
            "Proper handling of document-specific requirements",
            "Faster processing through established channels",
            "Avoidance of common mistakes that cause rejection",
            "Doorstep pickup and delivery",
            "Real-time status updates"
          ]
        },
        {
          type: "heading",
          text: "Conclusion"
        },
        {
          type: "paragraph",
          text: "Understanding the difference between apostille and attestation is essential for successful document legalization. While apostille is simpler and faster, attestation is required for many Gulf and Asian countries. Always verify the requirements of your destination country before proceeding. For expert guidance and hassle-free service, contact Advocate Pandey & Associates."
        }
      ]
    },
    {
      slug: "what-is-apostille-complete-guide-india",
      title: "What is Apostille? Complete Guide for Documents in India",
      image: blog1,
      date: "02-04-2026",
      readTime: "8 min read",
      author: "Adv. Neeraj Pandey",
      content: [
        {
          type: "paragraph",
          text: "Apostille is a term that has gained significant importance in recent years as more Indians travel abroad for education, employment, and immigration. If you are planning to use your Indian documents internationally, understanding apostille is crucial. This comprehensive guide will explain everything you need to know about apostille in India."
        },
        {
          type: "heading",
          text: "What is Apostille?"
        },
        {
          type: "paragraph",
          text: "Apostille is a certificate issued by the Ministry of External Affairs (MEA), Government of India, that authenticates the origin of a public document. The term 'apostille' comes from French and means 'certification' or 'annotation'. The apostille certificate is attached to your original document and verifies the authenticity of signatures, seals, or stamps on the document."
        },
        {
          type: "heading",
          text: "The Hague Convention of 1961"
        },
        {
          type: "paragraph",
          text: "The apostille process was established by the Hague Convention Abolishing the Requirement of Legalisation for Foreign Public Documents, commonly known as the Apostille Convention. This international treaty was signed in The Hague, Netherlands, on October 5, 1961, and has been ratified by over 120 countries, including India."
        },
        {
          type: "paragraph",
          text: "The convention simplifies the document legalization process between member countries by replacing the lengthy chain of authentications with a single apostille certificate."
        },
        {
          type: "heading",
          text: "Why Do You Need Apostille?"
        },
        {
          type: "paragraph",
          text: "You need apostille for your Indian documents when:"
        },
        {
          type: "list",
          items: [
            "Applying for a student visa to study abroad",
            "Seeking employment in a foreign country",
            "Immigrating to another country",
            "Getting married to a foreign national",
            "Starting a business overseas",
            "Transferring property abroad",
            "Applying for residency permits"
          ]
        },
        {
          type: "heading",
          text: "Types of Documents That Can Be Apostilled"
        },
        {
          type: "subheading",
          text: "1. Educational Documents"
        },
        {
          type: "paragraph",
          text: "Educational documents include degree certificates, diplomas, transcripts, mark sheets, school leaving certificates, and other academic records. These documents are typically required for higher education abroad or employment verification."
        },
        {
          type: "subheading",
          text: "2. Personal Documents"
        },
        {
          type: "paragraph",
          text: "Personal documents include birth certificates, marriage certificates, death certificates, police clearance certificates (PCC), affidavits, and medical certificates. These are often required for immigration, visa applications, and family matters."
        },
        {
          type: "subheading",
          text: "3. Commercial Documents"
        },
        {
          type: "paragraph",
          text: "Commercial documents include certificates of incorporation, memorandums of association, power of attorney, invoices, certificates of origin, and other business documents. These are required for international trade and business expansion."
        },
        {
          type: "heading",
          text: "The Apostille Process in India"
        },
        {
          type: "paragraph",
          text: "The apostille process in India follows a structured flow depending on the document type:"
        },
        {
          type: "subheading",
          text: "For Educational Documents"
        },
        {
          type: "numbered-list",
          items: [
            "Notary Attestation (initial verification by a notary public)",
            "HRD Attestation (attestation from the Human Resource Development department of the respective state)",
            "MEA Apostille (final apostille stamp from Ministry of External Affairs)"
          ]
        },
        {
          type: "subheading",
          text: "Alternative Process for Educational Documents (SDM Route)"
        },
        {
          type: "numbered-list",
          items: [
            "Notary Attestation",
            "SDM Attestation (Sub-Divisional Magistrate, an alternative to HRD)",
            "MEA Apostille"
          ]
        },
        {
          type: "subheading",
          text: "For Personal Documents"
        },
        {
          type: "numbered-list",
          items: [
            "Notary Attestation",
            "Home Department/State Attestation (or SDM Attestation)",
            "MEA Apostille"
          ]
        },
        {
          type: "subheading",
          text: "For Commercial Documents"
        },
        {
          type: "numbered-list",
          items: [
            "Notary Attestation",
            "Chamber of Commerce Attestation",
            "MEA Apostille"
          ]
        },
        {
          type: "heading",
          text: "Where Can You Get Apostille in India?"
        },
        {
          type: "paragraph",
          text: "The Ministry of External Affairs (MEA) has authorized the following Regional Authentication Centers (RACs) to process apostille:"
        },
        {
          type: "list",
          items: [
            "New Delhi (Headquarters)",
            "Mumbai",
            "Chennai",
            "Kolkata",
            "Hyderabad"
          ]
        },
        {
          type: "paragraph",
          text: "Documents can be submitted directly at these centers or through authorized service providers like Advocate Pandey & Associates."
        },
        {
          type: "heading",
          text: "Documents Required for Apostille"
        },
        {
          type: "paragraph",
          text: "The following documents are generally required for apostille:"
        },
        {
          type: "list",
          items: [
            "Original document to be apostilled",
            "Clear copy of the applicant's passport (first and last page)",
            "Authorization letter (if using a service provider)",
            "Supporting documents (if required for specific document types)"
          ]
        },
        {
          type: "heading",
          text: "Processing Time and Cost for Apostille"
        },
        {
          type: "paragraph",
          text: "Processing Time: Typically 2-7 working days for most documents. Educational documents may take 10-15 working days due to HRD verification. The MEA apostille itself takes 1-2 working days."
        },
        {
          type: "paragraph",
          text: "Cost: The MEA charges a fee of approximately ₹50-100 per document for apostille. Additional charges apply for notary, state attestation, and service provider fees. Total costs typically range from ₹2,000 to ₹5,000 per document depending on the document type and required attestations."
        },
        {
          type: "heading",
          text: "Common Mistakes to Avoid During Apostille"
        },
        {
          type: "list",
          items: [
            "Submitting laminated documents (apostille cannot be applied on laminated documents)",
            "Submitting photocopies instead of originals",
            "Documents with alterations or corrections without proper authentication",
            "Expired documents (especially police clearance certificates)",
            "Incomplete documentation (missing passport copy or authorization letter)",
            "Wrong attestation sequence (skipping required steps)"
          ]
        },
        {
          type: "heading",
          text: "Apostille vs. Attestation: Which One Do You Need?"
        },
        {
          type: "paragraph",
          text: "The choice between apostille and attestation depends on your destination country:"
        },
        {
          type: "paragraph",
          text: "Choose Apostille if: Your destination country is a member of the Hague Convention (USA, UK, Australia, Canada, France, Germany, Italy, Spain, Japan, etc.)"
        },
        {
          type: "paragraph",
          text: "Choose Attestation if: Your destination country is NOT a member of the Hague Convention (UAE, Saudi Arabia, Qatar, Kuwait, China, Egypt, etc.)"
        },
        {
          type: "heading",
          text: "Benefits of Using Professional Apostille Services"
        },
        {
          type: "list",
          items: [
            "Expert guidance on document requirements",
            "Doorstep pickup and delivery across India",
            "Faster processing through established relationships",
            "Avoidance of common mistakes and rejections",
            "Real-time tracking and updates",
            "Competitive pricing with transparent fees",
            "Handling of complex or problematic documents"
          ]
        },
        {
          type: "heading",
          text: "Why Choose Advocate Pandey & Associates?"
        },
        {
          type: "paragraph",
          text: "Advocate Pandey & Associates offers:"
        },
        {
          type: "list",
          items: [
            "10+ years of experience in document attestation and apostille",
            "Legal expertise led by Advocate Neeraj Pandey",
            "Nationwide pickup and delivery service",
            "Transparent pricing with no hidden charges",
            "High success rate for document approvals",
            "Dedicated customer support throughout the process"
          ]
        },
        {
          type: "heading",
          text: "Frequently Asked Questions About Apostille"
        },
        {
          type: "subheading",
          text: "Q: How long is an apostille valid?"
        },
        {
          type: "paragraph",
          text: "An apostille does not have an expiry date. However, some countries may require documents issued within 6-12 months for specific purposes like marriage or immigration."
        },
        {
          type: "subheading",
          text: "Q: Can I apostille documents without notary?"
        },
        {
          type: "paragraph",
          text: "No, notary attestation is mandatory for personal and commercial documents. Educational documents may bypass notary if they are direct university-issued certificates."
        },
        {
          type: "subheading",
          text: "Q: Is HRD attestation mandatory for educational documents?"
        },
        {
          type: "paragraph",
          text: "HRD attestation is mandatory for educational documents from certain states. However, the SDM route provides an alternative for those who cannot obtain HRD attestation."
        },
        {
          type: "subheading",
          text: "Q: What if my university is not recognized by UGC?"
        },
        {
          type: "paragraph",
          text: "Documents from non-UGC recognized universities cannot be apostilled. You will need to check with your university about alternative verification options."
        },
        {
          type: "subheading",
          text: "Q: Can I apostille documents in any language?"
        },
        {
          type: "paragraph",
          text: "Documents in regional languages may need to be translated into English or Hindi before apostille. The translation must be certified."
        },
        {
          type: "heading",
          text: "Conclusion"
        },
        {
          type: "paragraph",
          text: "Apostille is a straightforward process when you understand the requirements and follow the correct procedure. Whether you need apostille for personal, educational, or commercial documents, working with an experienced service provider like Advocate Pandey & Associates can save you time, money, and frustration. Contact us today for expert assistance with all your apostille needs."
        }
      ]
    }
  ];

  const blog = blogData.find((b) => b.slug === slug);

  if (!blog) {
    return (
      <div className="not-found-container">
        <h2>Blog Not Found</h2>
        <Link to="/blogs">Back to Blogs</Link>
      </div>
    );
  }

  // Helper function to render content based on type
  const renderContent = (item, index) => {
    switch (item.type) {
      case "heading":
        return <h2 key={index} className="blog-heading">{item.text}</h2>;
      case "subheading":
        return <h3 key={index} className="blog-subheading">{item.text}</h3>;
      case "paragraph":
        return <p key={index} className="blog-paragraph">{item.text}</p>;
      case "list":
        return (
          <ul key={index} className="blog-list">
            {item.items.map((listItem, i) => (
              <li key={i}>{listItem}</li>
            ))}
          </ul>
        );
      case "numbered-list":
        return (
          <ol key={index} className="blog-numbered-list">
            {item.items.map((listItem, i) => (
              <li key={i}>{listItem}</li>
            ))}
          </ol>
        );
      default:
        return null;
    }
  };

  return (
    <div className="blog-page-bg">
      <div className="blog-container">
        {/* MAIN CONTENT AREA */}
        <main className="blog-main-content">
          <div className="blog-header">
            <h1 className="blog-detail-title">{blog.title}</h1>
            <div className="blog-meta">
              <span className="blog-date2">📅 {blog.date}</span>
            </div>
          </div>
          
          <div className="blog-main-image">
            <img src={blog.image} alt={blog.title} />
          </div>

          <div className="blog-text-content">
            {blog.content.map((item, index) => renderContent(item, index))}
          </div>

          <div className="blog-share-section">
            <h4>Share this article:</h4>
            <div className="share-buttons">
              <button className="share-btn facebook">Facebook</button>
              <button className="share-btn twitter">Twitter</button>
              <button className="share-btn linkedin">LinkedIn</button>
              <button className="share-btn whatsapp">WhatsApp</button>
            </div>
          </div>

          <Link to="/blog" className="back-btn-link">
            ← Back to Blogs
          </Link>
        </main>

        {/* SIDEBAR AREA */}
        <aside className="blog-sidebar">
          <div className="sidebar-section">
            <h3 className="sidebar-title">Recent Posts</h3>
            <div className="recent-posts-list">
              {blogData.map((item) => (
                <Link to={`/blog/${item.slug}`} key={item.slug} className="sidebar-post-item">
                  <img src={item.image} alt="" className="sidebar-thumb" />
                  <div className="sidebar-post-info">
                    <p className="sidebar-post-name">{item.title}</p>
                    <span className="sidebar-post-date">{item.date}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* <div className="sidebar-section">
            <h3 className="sidebar-title">Categories</h3>
            <ul className="categories-list">
              <li><Link to="/blogs?category=apostille">Apostille Guide</Link></li>
              <li><Link to="/blogs?category=attestation">Attestation Services</Link></li>
              <li><Link to="/blogs?category=visa">Visa Assistance</Link></li>
              <li><Link to="/blogs?category=frro">FRRO Services</Link></li>
              <li><Link to="/blogs?category=translation">Document Translation</Link></li>
            </ul>
          </div> */}

          <div className="sidebar-section">
            <h3 className="sidebar-title">Popular Keywords</h3>
            <div className="keywords-grid">
              <span className="keyword-tag">Apostille India</span>
              <span className="keyword-tag">MEA Apostille</span>
              <span className="keyword-tag">Document Attestation</span>
              <span className="keyword-tag">Degree Certificate</span>
              <span className="keyword-tag">Marriage Certificate</span>
              <span className="keyword-tag">Birth Certificate</span>
              <span className="keyword-tag">Police Clearance</span>
              <span className="keyword-tag">Embassy Attestation</span>
              <span className="keyword-tag">HRD Attestation</span>
              <span className="keyword-tag">Visa Services</span>
            </div>
          </div>

          <div className="sidebar-section contact-sidebar">
            <h3 className="sidebar-title">Need Help?</h3>
            <p>Get expert assistance for your document needs</p>
            <a href="tel:+916393244687" className="contact-sidebar-btn">Call Now: +91 6393244687</a>
            <a href="/contact" className="contact-sidebar-btn secondary">Contact Us</a>
          </div>
        </aside>
      </div>
    </div>
  );
}